export * from 'mobx'
export {Provider} from 'mobx-react'
export {observer, Observer, useLocalStore, useAsObservableSource} from 'mobx-react-lite'
export * from 'mobx-utils'
import {observer as classObserver} from 'mobx-react'
export {classObserver}
import stringify from 'json-stable-stringify'
import {autorun, IReactionPublic, Reaction, configure} from 'mobx'
import * as React from 'react'
configure({isolateGlobalState: true})

interface MyProps {
  children: () => void;
  name?: string;
}

export class Autorun extends React.Component<MyProps, {}> {
  _dispose: Function[] = [];

  componentWillMount() {
    const {name} = this.props;  // non-reactive

    this._dispose.push(
      autorun(() => {
        var f = this.props.children as Function;
        f && f();
      }, {name})
    )
  }

  componentWillUnmount() {
    this._dispose.forEach(f => f());
  }

  render() {
    return null;
  }
}

window['toJS'] = (item) => toJS(item, {recurseEverything: true})

export const jsonComputedOptions = {
  equals: (a, b) => {
    const r = stringify(a) === stringify(b)
    //console.log({equal: r, a, b})
    return r
  }
}

export function debounceEffect<T>(effect: (arg: T, r: IReactionPublic) => void, debounceMs: number) {
  let timer: number
  return (arg: T, r: IReactionPublic) => {
    clearTimeout(timer)
    timer = window.setTimeout(() => effect(arg, r), debounceMs)
  }
}

import {flow, isObservable, runInAction, toJS} from 'mobx'

export {} from 'mobx-react'

// export * from 'mobx'
// export * from 'mobx-react'

export const runAsync = (f: Function, timeout = 0) => {
  return flow(function* () {
    setTimeout(f, timeout)
  })
}
// export const runInActionAsync = async <T>(description: string, f: () => T, timeout = 0) => {
//   setTimeout(() => runInAction(description, f), timeout)
// }

import {reaction} from "mobx";
import {isEqual} from "lodash";

export const reactionWithOldValue = <T>(
  expression: () => T,
  effect: (newValue: T, oldValue?: T) => void,
  options?
) => {
  let oldValue: T;
  return reaction(expression, v => {
    if (!isEqual(v, oldValue)) {
      effect(v, oldValue);
      oldValue = v;
    }
  }, options);
};

/**
 * Add this file to chrome ignore scripts to fix your log line number
 * @param message
 * @param optionalParams
 */
export const logJS = (message?: any, ...optionalParams: any[]) => {
  console.log(toJS(message, {recurseEverything: true}), optionalParams)
}

export const toJSRecurse = (obj?: any) => {
  return toJS(obj, {recurseEverything: true})
}

window['logJS'] = logJS

const nativeConsoleLog = console.log
const myLog = (message?: any, ...optionalParams: any[]) => {
  nativeConsoleLog(isObservable(message) ? toJS(message) : message, optionalParams ? optionalParams.map(v => isObservable(v) ? toJS(v) : v) : null)
}

console.log.bind(myLog)

export function autorunAsync(func, delay, scope) {
  if (delay === void 0) {
    delay = 1
  }
  if (scope) func = func.bind(scope)
  var isScheduled = false
  var r = new Reaction(func.name || "AutorunAsync", function () {
    if (!isScheduled) {
      isScheduled = true
      setTimeout(function () {
        isScheduled = false
        if (!r.isDisposed) r.track(func)
      }, delay)
    }
  })
  r.runReaction()
  return r.getDisposer()
}

// TODO - uncomment for 21.PF
// const fnLogDebug = console.debug
// console.debug = (message?: any, ...optionalParams: any[]): void => DEBUG ? fnLogDebug(message, optionalParams) : undefined


// WEBPACK FOOTER //
// ./src/shared/components/3rd-party/mobx.ts